import React, { useState } from "react";
import { Button, Stack } from "@mui/material";
import MissionSectionSlider from "src/scenes/dashboard/overview-components/mission-section-slider";
import styled from "styled-components";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import TodayIcon from "@mui/icons-material/Today";
import { differenceInDays, format } from "date-fns";
import SingleDatePickerModal from "src/components/single-date-picker-modal";

const DescriptionText = styled.h1`
    font-size: 12px;
    font-weight: 300;
`;

const CreateButton = styled(Button)`
    font-size: 12px;
    margin-top: 12px;
    max-width: 200px;
`;

const MissionsSectionComponent = ({
    isDemo,
    allMissions,
    selectedMissionId,
    selectedCategory,
    missionTarget,
    setMissionTarget,
    missionEndDate,
    setMissionEndDate,
    handleSubmitStart,
}) => {
    const [selectedMissionData, setSelectedMissionData] = useState([]);
    const [datepickerModalOpen, setDatepickerModalOpen] = useState(false);
    React.useEffect(() => {
        const selectedMission = allMissions[selectedCategory].find(
            (mission) => mission.missionId === selectedMissionId
        );
        setSelectedMissionData(selectedMission);
    }, [selectedMissionId, selectedCategory]);

    if (!selectedMissionData) return null;

    return (
        <Stack direction="column" justifyContent="space-between" pt={1}>
            <Stack direction="column">
                <DescriptionText>
                    {selectedMissionData &&
                        selectedMissionData.description &&
                        selectedMissionData.description
                            .split(/(__target__|__target_comparison__)/)
                            .map((part) => {
                                if (part === "__target__") {
                                    return <strong key={part}>{missionTarget}</strong>;
                                }
                                if (part === "__target_comparison__") {
                                    if (
                                        !selectedMissionData.targetComparison ||
                                        selectedMissionData.targetComparison === "gte"
                                    ) {
                                        return <span key={part}>greater than</span>;
                                    }
                                    return <span key={part}>less than</span>;
                                }
                                return <span key={part}>{part}</span>;
                            })}
                </DescriptionText>
                <MissionSectionSlider
                    missionTarget={missionTarget}
                    setMissionTarget={setMissionTarget}
                    min={selectedMissionData.min}
                    max={selectedMissionData.max}
                    step={selectedMissionData.step}
                    isDemo={isDemo}
                />
            </Stack>
            <Stack direction="row" spacing={0.5} alignItems="center">
                <DescriptionText>Complete mission by </DescriptionText>
                <DescriptionText style={{ fontWeight: 500 }}>
                    {format(new Date(missionEndDate.getTime()), "PPP")}
                </DescriptionText>
                <DescriptionText style={{ fontWeight: 500 }}>
                    ({differenceInDays(new Date(missionEndDate), new Date()) + 1} days)
                </DescriptionText>
            </Stack>
            <CreateButton
                variant="contained"
                size="medium"
                startIcon={<TodayIcon />}
                style={{ marginBottom: "12px" }}
                onClick={() => setDatepickerModalOpen(true)}
            >
                Change Date
            </CreateButton>
            <CreateButton
                variant="contained"
                size="medium"
                startIcon={<AddCircleIcon />}
                style={{ marginBottom: "12px" }}
                onClick={isDemo ? null : handleSubmitStart}
            >
                Create
            </CreateButton>
            <SingleDatePickerModal
                open={datepickerModalOpen}
                missionEndDate={missionEndDate}
                setMissionEndDate={setMissionEndDate}
                setDatepickerModalOpen={setDatepickerModalOpen}
            />
        </Stack>
    );
};

export default MissionsSectionComponent;
